'use strict';

import GuaranteeReportForm from "./utils/guarantee-report-form";

(new GuaranteeReportForm());


// WEBPACK FOOTER //
// ./assets/js/guarantee-report-create.js